import { Stack, Group, Text, Badge, Code, ScrollArea, Table, EmptyState } from '../../../../components/ui';
import { IconBrandDocker } from '@tabler/icons-react';
import { getStatusColor, getStatusIcon, formatUptime } from '../utils/systemHelpers.tsx';
import type { ServicesTabProps } from '../types';

export function ServicesTab({ services }: ServicesTabProps) {
  if (!services || services.length === 0) {
    return (
      <EmptyState
        icon={<IconBrandDocker size={64} />}
        title="No Services Found"
        description="No microservices are currently registered."
      />
    );
  }

  return (
    <Stack gap="md">
      <Group gap="sm">
        <IconBrandDocker size={20} />
        <Text size="md" fw={600}>
          Microservices Status
        </Text>
      </Group>

      <ScrollArea>
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Service</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th>Health</Table.Th>
              <Table.Th>Version</Table.Th>
              <Table.Th>Uptime</Table.Th>
              <Table.Th>URL</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {services.map((service) => (
              <Table.Tr key={service.name}>
                <Table.Td>
                  <Text size="sm" fw={600}>
                    {service.name}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Badge color={getStatusColor(service.status)} variant="light" leftSection={getStatusIcon(service.status)}>
                    {service.status}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  {service.healthStatus ? (
                    <Badge color={getStatusColor(service.healthStatus)} size="sm">
                      {service.healthStatus}
                    </Badge>
                  ) : (
                    <Text size="xs" c="dimmed">
                      N/A
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <Code>{service.version}</Code>
                </Table.Td>
                <Table.Td>
                  <Text size="xs">{service.uptime ? formatUptime(service.uptime) : 'N/A'}</Text>
                </Table.Td>
                <Table.Td>
                  <Code size="xs">{service.url}</Code>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Stack>
  );
}
